import type { CSSObject } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const day: CSSObject = {
  backgroundColor: '#eff0f2',
  boxSizing: 'border-box',
  blockSize: '100%',
  paddingBlock: Spacing.M,
  paddingInline: Spacing.S,
  position: 'relative',
}

export const dayWrapper: CSSObject = {
  minBlockSize: 178,
}
